// extracted by mini-css-extract-plugin
export default {"buttonIconSmall":"button-icon-small_component_buttonIconSmall__CALSQ"};